import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const RefundPolicy = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-white text-gray-800 font-sans">
            <div className="max-w-4xl mx-auto px-4 py-12 sm:px-6 lg:px-8">
                <button
                    onClick={() => navigate('/')}
                    className="flex items-center gap-2 text-amber-700 hover:text-amber-800 font-semibold mb-8 transition-colors"
                >
                    <ArrowLeft size={20} />
                    Back to Home
                </button>

                <h1 className="text-4xl font-bold text-gray-900 mb-8 border-b pb-4 border-amber-100">Refund & Cancellation Policy</h1>

                <div className="space-y-6 text-lg leading-relaxed">
                    <p>
                        Thank you for choosing Nayan's Kitchen & Delights for your authentic Maharashtrian meals. Please review our refund and cancellation policies outlined below.
                    </p>

                    <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">1. General Policy</h2>
                    <p>
                        We do not offer refunds for IT services, software solutions, digital consulting, or processed food orders once preparation has begun, as the nature of our products is consumable and individually prepared.
                    </p>

                    <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">2. Order Cancellations</h2>
                    <p>
                        Because we follow a T+1 delivery system starting the ingredient preparation well in advance, any cancellations must be made at least 12 hours prior to the scheduled delivery time. Cancellations requested after this period may not be eligible for a refund.
                    </p>

                    <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">3. Incorrect or Damaged Items</h2>
                    <p>
                        If you receive an incorrect item or if your order arrives damaged, please contact us immediately upon receipt. Do not consume or discard the item. Please take a photograph and share it with us at hellonayanskitchen@gmail.com, so we may evaluate the issue and consider an appropriate remedy (such as replacement).
                    </p>

                    <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">4. Process for Approved Refunds</h2>
                    <p>
                        In exceptional cases where a refund is approved by our management team, the amount will be processed back to your original method of payment (e.g., Credit Card, UPI, etc.). The refund usually takes 5-7 business days to reflect in your account depending on your bank's processing times.
                    </p>

                    <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">5. Contact Us</h2>
                    <p>
                        If you have questions about your order or need assistance, you may reach out to us:
                        <br /><br />
                        <strong>Email:</strong> hellonayanskitchen@gmail.com<br />
                        <strong>Phone:</strong> +91 99755 12357
                    </p>
                </div>
            </div>
        </div>
    );
};

export default RefundPolicy;
